import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63016bb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current_date" }
const _hoisted_2 = { class: "archive_display_time" }
const _hoisted_3 = { class: "archive_display_time_label" }

import { formatSecondStr, formatDateStr } from '@/js/utils/filters'
import { computed, ref, withDefaults } from 'vue'

type PropsType = {
  startTime: string
  currentTime?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArchiveDisplayTime',
  props: {
    startTime: null,
    currentTime: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { startTime: string, currentTime: number };



/**
 * 現在表示している過去映像の日時
 */
const currentDate = computed<string>(() => {
  const date = ref<string>(formatDateStr(props.startTime, 'YYYY/MM/DD HH:mm'))
  const time = ref<string>(formatSecondStr(props.currentTime).slice(-2))
  return `${date.value}:${time.value}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('archive_display_time.label')), 1),
      _createTextVNode(" " + _toDisplayString(_unref(currentDate)), 1)
    ])
  ]))
}
}

})